export default {
  topBar: {
    device: {
      deviceRotate: 'デバイス解像度',
      select: '選択してください',
    },
    playScene: {
      play: '再生シーン',
      pause: '初期状態に戻る',
    },
  },
  takeColor: {
    bindEventMessage: 'ゲームがまだ完全に読み込まれていません',
  },
  bottomBar: {
    scaleManager: {
      validateTips: 'ズーム値は50-200の間で設定する必要があります',
    },
    estimateSize: {
      packageEstimate: 'パッケージ見積もり',
      packageEstimating: 'パッケージ見積もり中',
      packageEstimateTip:
        '制作中はパッケージサイズを随時確認し、サイズ制限を超えないようにしてください。',
      high: 'ハイクオリティ',
      middle: '中クオリティ',
      low: 'ロークオリティ',
      packageLimitTip: 'パッケージサイズ制限',
    },
  },
  device: {
    orientationList: {
      horizontal: '横向き',
      portrait: '縦向き',
    },
    adaptToTheScreen: 'スクリーンに合わせる',
  },
}
